module.exports = __webpack_public_path__ + "img/1575911596.a3c2387b.jpg";